import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowSplitLeft"><Path d="M10 4.5H5.56055L12.3105 11.25H21V12.75H12.3105L5.56055 19.5H10V21H3V14H4.5V18.4395L10.9395 12L4.5 5.56055V10H3V3H10V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowSplitLeft;
